// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"295402d9","75":"84d02ddb","348":"57418676","380":"cb2275f0","394":"10cc32ad","480":"70042051","655":"b8cf55e6","846":"3fdb7b2e","891":"6ff27898"}[chunkId] + ".chunk.js";
};